import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../core/config.service';
import {Injectable} from '@angular/core';


@Injectable()
export class NodeGraphService {
  constructor(private configService: ConfigService,
    private httpClient: HttpClient) {
  }

   getNodeMetaData(body: any): any {
    const url = this.configService.getNodeDataUrl() + '/nodeData/metaData';
    return this.httpClient.post(url, body).toPromise();
  }
  
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/node-graphs/node-graph.service.ts